import { useToast } from '@components/index'
import { useTranslation } from 'react-i18next'
import { ApiError } from './ApiError'

export function useOnError() {
  const { t } = useTranslation('backend')
  const toast = useToast()

  return function onError<T extends Partial<ApiError>>(error: T) {
    // The backend sends messages like "backend.wrong_initial_password"
    // Our translation files have structure: { "backend": { "wrong_initial_password": "..." } }
    // So we need to keep the full path when using the 'backend' namespace
    const messageKey = error.message ?? ''

    // Unmapped messages fall back to the raw backend text when it reads as a
    // sentence (better than a generic toast); key-like strings stay generic.
    const fallback = messageKey.includes(' ')
      ? messageKey
      : t('backend.unknown_error', 'An error occurred')
    const translatedMessage = t(messageKey, { defaultValue: fallback })

    toast.error({ message: translatedMessage })
  }
}
